export default __webpack_public_path__ + "static/media/card2.a29a27c9.png";